import React from 'react'
import { extractSubType, StripTags, eventTriggerGA, escapeString } from 'scripts/lib/utils'
import { Helmet } from 'react-helmet'
import Constants from 'scripts/base/Constants'

const pubdateTimeStamp = (date) => {
  const pubDate = new Date(date * 1000)
  return pubDate.toLocaleString('en-US',
    {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    }).replace(',', '')
}

const Metas = (props) => {
  const { article: {images, createdAt: date, title, author, content, associatedWith}, ssr, pageURL, lang } = props
  const imageURL = images && images.header ? `${images.header.url}?s=900x600&e=t` : null
  const titleText = title ? title.text : null
  if (!titleText) { return null } // block
  const tags = associatedWith ? [...extractSubType(associatedWith, 'tag'), ...extractSubType(associatedWith, 'fanClub')] : []
  const cate = associatedWith ? extractSubType(associatedWith, 'category') : []

  const pageTitle = `${titleText} | Soompi`
  const contentPreview = content ? StripTags(content.previewTextHTML) : null
  const authorName = author ? author.displayName : null
  const articleURL = !ssr ? window.location.href : pageURL

  const categoriesTag = cate.map((item, index) => {
    return <meta key={index} property="article:section" content={`${item.name}`} />
  })
  const tagsTag = tags.map((item, index) => {
    return <meta key={index} property="article:tag" content={`${item.name}`} />
  })
  const { StaticStructHome, StaticStructSearch } = Constants.MetaDefaults

  return (
    <Helmet onChangeClientState={eventTriggerGA}>
      <title defer={false}>{pageTitle}</title>
      <link rel="canonical" href={articleURL} />
      <meta name="title" content={pageTitle} />
      <meta name="description" content={contentPreview} />
      {categoriesTag}
      {tagsTag}
      <meta property="article:published_time" content={date} />
      <meta property="og:url" content={articleURL} />
      <meta property="og:title" content={titleText} />
      <meta property="og:image" content={imageURL} />
      <meta property="og:description" content={contentPreview} />
      <meta name="twitter:title" content={titleText} />
      <meta name="twitter:image" content={imageURL} />
      <meta name="twitter:description" content={contentPreview} />
      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org",
          "@type": "Article",
          "author":{
              "@type":"Person",
              "name":"${authorName}"
          },
          "url":"${articleURL}",
          "image":"${imageURL}",
          "headline":"${escapeString(titleText)}",
          "datePublished":"${pubdateTimeStamp(date)}",
          "inLanguage":"en-US",
          "publisher":{
              "@type":"Organization",
              "name":"Soompi",
              "logo": {
                  "@type": "ImageObject",
                  "url": "https://0.soompi.io/soompi-web/logo.png",
                  "width": "178",
                  "height": "54"
              }
          }
        }`}
      </script>
      <script type="application/ld+json">{StaticStructHome[lang]}</script>
      <script type="application/ld+json">{StaticStructSearch[lang]}</script>
    </Helmet>
  )
}

export default Metas



// WEBPACK FOOTER //
// ./assets/js/components/article/Metas.jsx